var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.586 9.5H4a.5.5 0 00-.5.5v4a.5.5 0 00.5.5h1.586a2.5 2.5 0 011.768.732l3.292 3.293a.5.5 0 00.854-.354V5.828a.5.5 0 00-.854-.353L7.354 8.768a2.5 2.5 0 01-1.768.732zM4 8h1.586a1 1 0 00.707-.293l3.293-3.293C10.846 3.154 13 4.046 13 5.828v12.343c0 1.782-2.154 2.675-3.414 1.415l-3.293-3.293A1 1 0 005.586 16H4a2 2 0 01-2-2v-4a2 2 0 012-2zm15.265-2.65a.75.75 0 011.024.275A12.695 12.695 0 0121.995 12c0 2.321-.62 4.5-1.706 6.376a.75.75 0 01-1.298-.751A11.195 11.195 0 0020.495 12c0-2.05-.547-3.97-1.504-5.624a.75.75 0 01.274-1.025zm-2.436 2.275a.75.75 0 00-1.298.75A7.213 7.213 0 0116.5 12a7.213 7.213 0 01-.97 3.625.75.75 0 101.298.75A8.714 8.714 0 0018 12a8.713 8.713 0 00-1.17-4.375z",
    fill: "currentColor"
  })));
}

export default SvgVolume;